import React, { Children, cloneElement, useState } from "react";

interface IProps {
    onTabChange: (index: number) => void;
    children: React.ReactNode;
}

export const NFTabs = ({ onTabChange, children }: IProps) => {
    const [tabIndex, setTabIndex] = useState<number>(0);
    const arrayChildren = Children.toArray(children);

    return (
        <>
            <div className="d-flex" style={{ gap: '10px' }}>
                {arrayChildren.map((field: any, index) => {
                    return (
                        <React.Fragment key={index}>
                            {React.cloneElement(field, {
                                onTabClick: () => {
                                    setTabIndex(index);
                                    onTabChange(index);
                                },
                                active: index === tabIndex,
                            })}
                        </React.Fragment>
                    )
                })}
            </div>
            <hr style={{ opacity: "1" }} />
        </>
    )
}